import React, { useContext, useCallback } from 'react';
import { CanvasContext } from 'components/upload-image/CanvasContext';
import AdjustSliderControl from 'components/tools/adjust/AdjustSliderControl';

export default function BrightnessControl() {
  const { brightness, setBrightness } = useContext(CanvasContext);

  const handleStoredChange = useCallback(
    (next) => setBrightness(next),
    [setBrightness]
  );

  return (
    <AdjustSliderControl
      id="brightness"
      label="Brightness"
      value={brightness}
      onChange={handleStoredChange}
      min={0}
      max={200}
      step={1}
      defaultValue={1}
      toSlider={(stored) => Math.round(stored * 100)}
      fromSlider={(slider) => slider / 100}
      formatValue={(_stored, slider) => `${slider}%`}
    />
  );
}
